import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import { OccProductSearchAdapter, TranslatePipe } from '@spartacus/core';
import { FacetListComponent, FacetService, IconComponent } from '@spartacus/storefront';
import { BehaviorSubject, Observable } from 'rxjs';
import { ProductListService } from '../../../../nyab-doc-search-page/service/Product-list/product-list.service';
import { FacetKbComponent } from '../facet-kb/facet-kb.component';
import { AsyncPipe } from '@angular/common';


@Component({
    selector: 'app-facet-list-kb',
    templateUrl: './facet-list-kb.component.html',
    styleUrls: ['./facet-list-kb.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [
        IconComponent,
        FacetKbComponent,
        AsyncPipe,
        TranslatePipe,
    ],
})
export class FacetListKbComponent extends FacetListComponent implements OnInit {


  facetTabIndex: any = 0;
  docOrSoftware: boolean = false;

  constructor(
    facetService: FacetService,
    elementRef: ElementRef,
    renderer: Renderer2,
    public productListService: ProductListService,
    public searchService: OccProductSearchAdapter,
    private cdr: ChangeDetectorRef
  ) {
    super(facetService, elementRef, renderer);
  }
  override ngOnInit() {
    super.ngOnInit();
    this.productListService.selectedTabIndex.subscribe((data) => {
      this.facetTabIndex = data;
      if (this.facetTabIndex == 7 || this.facetTabIndex == 8) {
        this.docOrSoftware = true;
      } else {
        this.docOrSoftware = false;
      }
      this.cdr.detectChanges();
    });
  }
}
